import { createAppRouter } from '@core/utils/router/create-app-router'
import { routeTree } from '@platform/routeTree.gen'

export const router = createAppRouter(routeTree)

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
